var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center",style:({ height: _vm.height })},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size,"width":_vm.width,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }